function inToFt(inches) {
    if (inches.constructor === Array) {
        return [inches[0] * 0.0833333, inches[1] * 0.0833333];
    }

    return inches * 0.0833333;
}

export default {
    inToFt,
};
